<template>
  <ModalBase @close-modal="closeModal">
    <div class="modalLayout">
      <div class="magazineModal_icon">
        <img src="@/assets/images/icon/user2.svg" alt="" />
      </div>
      <p class="magazineModal_title">
        会員限定コンテンツになります。<br />ご利用には会員登録またはログインが必要です。
      </p>
      <p class="magazineModal_text">
        会員登録すると、「お気に入り登録」「イベントの予約」「チェックイン」など様々な機能が使えるようになります。また、会員限定のお役立ち情報や特集も満載！
      </p>
      <div class="magazineModal_btn">
        <Button
          label="会員登録する"
          secondary
          :href="`/register/user_category?q=${$route.path}`"
          :handleClick="() => goTo(`/register/user_category?q=${$route.path}`)"
        />
        <Button
          label="ログイン"
          primary
          border
          :href="`/login?q=${query}`"
          :handleClick="() => goTo(`/login?q=${query}`)"
        />
      </div>
    </div>
  </ModalBase>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import ModalBase from '@/components/genenral/ModalBase.vue'
import Button from '@/components/elements/Button.vue'

export default defineComponent({
  name: 'MagazineModal',

  components: {
    ModalBase,
    Button
  },

  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()

    const closeModal = () => {
      store.commit('unFixBody')
      store.dispatch('closeLimitedModal')
      router.push('/')
    }
    const query = computed(() => {
      return store.state.limitedModalLoginQuery
        ? store.state.limitedModalLoginQuery
        : route.path
    })

    const goTo = (path: string) => {
      router.push(path)
      store.dispatch('closeLimitedModal')
    }

    return {
      closeModal,
      goTo,
      query
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

::v-deep(.modal) {
  align-self: flex-end;
  width: 100%;
  max-width: 712px;
  padding: 20px 18px 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border: 1px solid #29ccc3;
  border-radius: 15px;
  margin: 0 16px;
  position: relative;

  @include mixins.media() {
    padding: 40px 90px 40px;
    margin: 0;
  }
}
.modalWrap {
  background: transparent;
  /* Note: currently only Safari supports backdrop-filter */
  backdrop-filter: blur(6px);
  --webkit-backdrop-filter: blur(6px);
  background-color: rgba(255, 255, 255, 0.08);
  /* (plus shape's fill blended on top as a separate layer with 40% opacity) */
}
.modalLayout {
  width: 100%;
  height: 100%;
  text-align: center;
}
::v-deep(.close) {
  top: -37px;
  right: 0;
}
.magazineModal_icon {
  margin-bottom: 10px;
}
.magazineModal_title {
  font-size: 1.8rem;
  line-height: 1.5;
  font-weight: 500;
  color: var.$color-main-text;
  margin-bottom: 8px;
}
.magazineModal_text {
  font-size: 1.4rem;
  line-height: 2;
  margin-bottom: 32px;
  text-align: left;
}
.magazineModal_btn {
  display: grid;
  gap: 20px;
  @include mixins.media() {
    gap: 16px;
    grid-template-columns: 215px 215px;
    justify-content: center;
  }
}
</style>
